import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";
import { Dimmer } from "../spinner";

const headCells = [
  {
    id: "1",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Código</p>,
    textAlign: "center",
  },
  {
    id: "2",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Periodo</p>,
    textAlign: "center",
  },
  {
    id: "3",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Cuenta Bancaria</p>,
    textAlign: "center",
  },
  {
    id: "8",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> N° Referencia</p>,
    textAlign: "center",
  },
  {
    id: "9",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Monto</p>,
    textAlign: "center",
  },
  {
    id: "4",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Monto Total</p>,
    textAlign: "center",
  },
  {
    id: "5",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Fecha de Verificación </p>,
    textAlign: "center",
  },
  {
    id: "6",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> N° de Factura </p>,
    textAlign: "center",
  },
  {
    id: "7",
    backgroundColor: "#3b8eed",
    color: "#ffffff",
    label: <p className="fw-bold"> Estatus</p>,
    textAlign: "center",
  },
];

const TablaVerificacionesProduc = (props) => {
  const [activate, setActivate] = useState(false);

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 280);

  const [url, setUrl] = useState("");

  useEffect(() => {
    if (props.verific) {
      setRecords(props.verific);
    }
  }, [props.verific]);

  return (
    <div className="card">
      <Dimmer active={activate} />
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row" style={{ margin: 0 }}>
              <div className="col-md-12" style={{ margin: "auto" }}>
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.anio + item.mes}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.idverificacion}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.periodo}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {item.cuentabancaria}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {item.nrodocumento}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.totalfactura.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechaverificacion).format(
                              "DD/MM/YYYY"
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.nrofactura}
                          </TableCell>
                          <TableCell
                            className="fw-bold"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              color: item.status === 1 ? "#008f39" : "#ffae00",
                            }}
                          >
                            {item.status === 1
                              ? "!Verificación¡ Pagada"
                              : "!Verificación¡ por Pagar"}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <TblPagination />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaVerificacionesProduc;



// WEBPACK FOOTER //
// ./src/components/impuesto1x500/tablaVerificaciones.js